<div class="card border border-success">
    <h5 class="card-header">{{proceso.Carrera?.Name ? proceso.Carrera?.Name : "Carrera no seleccionada"}}
        <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#CopagoArancel" role="button"
            aria-expanded="true" aria-controls="CopagoArancel">
        </a>
    </h5>

    <div class="collapse show" id="CopagoArancel">
        <div class="card-body">
            <div class="row">
                <div class="col-md-1">
                    <div class="d-flex justify-content-center">
                        <div class="d-flex align-items-center">
                            <em class="mdi mdi-file-document-box" style="font-size: 70px;"></em>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ml-1 p-1 bd-highlight">
                        <label>Estado del proceso: {{proceso.Estado?.Text}}</label>
                    </div>
                    <div class="ml-1 p-1 bd-highlight">
                        <label>Línea de negocio: {{proceso.LineaNegocio}}</label>
                    </div>
                    <div class="ml-1 p-1 bd-highlight">
                        <label>Fase: {{proceso.FasePortal?.Text}}</label>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="p-1 bd-highlight">
                        <label>Sede: {{proceso.Sede?.Name}}</label>
                    </div>
                    <div class="p-1 bd-highlight">
                        <label>Carrera: {{proceso.Carrera?.Name}}</label>
                    </div>
                    <div class="p-1 bd-highlight">
                        <label>Jornada: {{proceso.Jornada?.Text}}</label>
                    </div>
                </div>

                <div class="col-md-3">

                    <div class="text-center mt-3">
                        <div class="p-1 bd-highlight">
                            <h4>{{proceso.Dia}}</h4>
                        </div>
                        <div class="p-1 bd-highlight">
                            <h5>{{proceso.MesAnho}}</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <span class="btn btn-sm btn-success ml-3" (click)="ActualizarProceso()">
                    Actualizar
                </span>
                <span class="btn btn-sm btn-secondary ml-2" (click)="CancelarProceso()"
                    *ngIf="proceso.FasePortal.Value != '7' && !procesando">
                    Cancelar
                </span>
                <span class="btn btn-sm btn-secondary ml-2" *ngIf="proceso.FasePortal.Value != '7' && procesando"
                    style="cursor: default;">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Cancelar
                </span>
            </div>
        </div>
    </div>
</div>


<!-- Modal Bloqueo Académico -->
<div class="modal fade" id="modalBloqueoAcademico" tabindex="-1" aria-labelledby="modalBloqueoAcademico"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <p class="text-left">Estimado(a) Postulante:</p>
                <p class="text-left">
                    De acuerdo a nuestros registros tienes una situación académica que regularizar, te solicitamos tomar
                    contacto con la sede donde estudiaste anteriormente y regularizar tu situación antes de
                    matricularte. Revisa contactos en <a
                        href="https://www.tupuedes.cl/sistemas-de-admision/matricula-online/contacto-en-sede/">www.tupuedes.cl/sistemas-de-admision/matricula-online/contacto-en-sede/</a>
                </p>
                <p class="text-left">
                    Atentamente, <br /> Dirección de Admisión, Santo Tomás.
                </p>
            </div>
        </div>
    </div>
</div>
<!-- Modal Bloqueo Académico -->